(function () {
    angular.module('st')
        .controller('CelebrationContentTypeController', [
            '$rootScope', '$scope', '$sce', "$http",
            function ($rootScope, $scope, $sce, $http) {
                var ctrl = this;

                //lock toggle buttons while searching
                ctrl.searching = true;

                ctrl.toggle = function (facetCtrl,index,event) {                        
                        facetCtrl.toggle(index);
                }

                $rootScope.$on('stSearchResponse', function (e, response, group) { 
                        $scope.$applyAsync(ctrl.searching = false);
                });


                $rootScope.$on('stSearchUpdated', function (e, response, group) {      
                        $scope.$applyAsync(ctrl.searching = true); 
                });

            }]);
})();

